import { Card, CardContent } from "@/components/ui/card";

const FruitLogistica = () => {
  return (
    <Card className="overflow-hidden">
      <CardContent className="p-8">
        <h2 className="text-3xl font-bold mb-6 text-accent">
          <a 
            href="https://www.fruitlogistica.com/en/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="hover:text-accent/80 transition-colors"
          >
            FRUIT LOGISTICA
          </a>
        </h2>
        <p className="text-gray-600 mb-4">
          SPO is an active participant in <a 
            href="https://www.fruitlogistica.com/en/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-accent hover:text-accent/80 transition-colors"
          >FRUIT LOGISTICA</a>, FRUIT LOGISTICA is the leading trade show for the global fresh produce business and SPO consider it an important place for networking and exchanging ideas on projects, partnerships and collaboration.
        </p>
        <p className="text-gray-600">
          At FRUIT LOGISTICA 2023 more than 2,600 exhibitors from 92 countries displayed their products, services and technical solutions. Some 63,500 buyers and trade visitors from 140 countries took part in the event. The next FRUIT LOGISTICA will take place from 7 to 9 February 2024 in Berlin.
        </p>
      </CardContent>
    </Card>
  );
};

export default FruitLogistica;